import { useState } from "react";
import Head from "next/head";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import { Imgix, Hero, Section } from "../common/UI";
import withSession from "../lib/session";
import {
  Container,
  Paper,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
  Link,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Carousel } from "react-responsive-carousel";

const CircleImage = ({ src, imgixParams = {}, imgParams = {} }) => {
  return (
    <Box
      sx={{
        height: {
          xs: 80,
          md: 120,
        },
        width: {
          xs: 80,
          md: 120,
        },
        borderRadius: "50%",
        border: "1px solid #000",
        overflow: "hidden",
        margin: "0 auto",
      }}
    >
      <Imgix
        src={src}
        width={120}
        height={120}
        imgixParams={{ fit: "clamp", ...imgixParams }}
        htmlAttributes={{ style: {} }}
        {...imgParams}
      />
    </Box>
  );
};

export default function GearPage() {
  return (
    <Layout>
      <Grid item zeroMinWidth>
        <Hero minHeight={200}>
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Gear and Rentals
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h5"
              sx={{
                // textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              High quality equipment, available for rental!
            </Typography>
          </Box>
          {/* <Box sx={{}}>
            <Typography
              variant="body1"
              sx={{
                // textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              <Link href={"#prices"} underline="hover">
                (prices available at bottom of page)
              </Link>
            </Typography>
          </Box> */}
        </Hero>

        <br />

        <Typography variant="h5" sx={{ textAlign: "center" }} paragraph>
          Listed below are our rental options and pricing:
        </Typography>

        <Divider />

        {/* <Container sx={{ minWidth: 0, overflowX: "auto", width: "100%" }}> */}
        <Container
          sx={{
            padding: { xs: 0 },
            maxWidth: { xs: "100vw" },
            background: "#f6fbff",
          }}
        >
          {/* <Typography variant="h4">Options and Pricing</Typography> */}
          <TableContainer id="prices">
            <Table sx={{ minWidth: "800px" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ position: "sticky", left: 0, background: "#f6fbff" }}
                  ></TableCell>
                  <TableCell>
                    Soft Top Surboard.
                    <br />
                    Boogie Board.
                    <br />
                    "Touring" SUP.
                  </TableCell>
                  <TableCell>
                    Hard Top Surfboard.
                    <br />
                    "Surfing" SUP.
                  </TableCell>
                  <TableCell>Wetsuit</TableCell>
                  <TableCell>Booties / etc</TableCell>
                  <TableCell>
                    Soft Top Package <br />
                    (board, wetsuit, booties)
                  </TableCell>
                  <TableCell>
                    Hard Top Package <br />
                    (board, wetsuit, booties)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fafafa",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    1 Hour
                  </TableCell>
                  <TableCell>$10</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $15
                  </TableCell>
                  <TableCell>$10</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $5
                  </TableCell>
                  <TableCell>$20 (save $5)</TableCell>
                  <TableCell>$25 (save $5)</TableCell>
                </TableRow>
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fafafa",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    2 Hours
                  </TableCell>
                  <TableCell>$20</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $30
                  </TableCell>
                  <TableCell>$20</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $5
                  </TableCell>
                  <TableCell>$40 (save $5)</TableCell>
                  <TableCell>$45 (save $10)</TableCell>
                </TableRow>
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fafafa",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    Half Day
                    <br />
                    (Most Popular!)
                  </TableCell>
                  <TableCell>$30</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $45
                  </TableCell>
                  <TableCell>$25</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $5
                  </TableCell>
                  <TableCell>$50 (save $10)</TableCell>
                  <TableCell>$55 (save $20)</TableCell>
                </TableRow>
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fafafa",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    1 Day
                  </TableCell>
                  <TableCell>$40</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $60
                  </TableCell>
                  <TableCell>$30</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $5
                  </TableCell>
                  <TableCell>$65 (save $10)</TableCell>
                  <TableCell>$75 (save $20)</TableCell>
                </TableRow>
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fafafa",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    2 Days
                  </TableCell>
                  <TableCell>$60</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $80
                  </TableCell>
                  <TableCell>$35</TableCell>
                  <TableCell sx={{ borderRight: "1px solid black" }}>
                    $5
                  </TableCell>
                  <TableCell>$85 (save $15)</TableCell>
                  <TableCell>$95 (save $25)</TableCell>
                </TableRow>
                <TableRow
                  sx={
                    {
                      // "&:last-child td, &:last-child th": { border: 0 },
                    }
                  }
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fafafa",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    3+ Days
                  </TableCell>
                  <TableCell
                    // colSpan={6}
                    sx={{ position: "sticky", left: "105px" }}
                  >
                    Call us for discounts!
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
        {/* </Container> */}
        <br />
        <br />

        <Box sx={{ textAlign: "center" }}>
          <Button
            color="success"
            variant="contained"
            size="large"
            href="/rentals/signup"
          >
            Signup for Rentals
          </Button>
        </Box>
        <br />
        <br />
        <Grid container sx={{ margin: { md: "24px 0" } }} wrap="nowrap">
          <Grid item xs={4} sx={{ textAlign: "center" }}>
            <a href="#surfboards">
              <CircleImage
                src={
                  "https://bigsurf1public.imgix.net//public/2b122d8b-6449-42ad-8cdf-683fb8d1961b.jpg"
                }
              />
              <Typography variant="h6">Surfboards</Typography>
            </a>
          </Grid>
          <Grid item xs={4} sx={{ textAlign: "center" }}>
            <a href="#boogie">
              <CircleImage
                src={
                  "https://bigsurf1public.imgix.net//public/decc5efd-6727-4fcd-b90d-833c7fd8ef80.png"
                }
              />
              <Typography variant="h6">Boogie Boards</Typography>
            </a>
          </Grid>
          <Grid item xs={4} sx={{ textAlign: "center" }}>
            <a href="#wetsuits">
              <CircleImage
                src={
                  "https://bigsurf1public.imgix.net//public/c7786d49-d90d-49df-a447-98ff6f6bc196.jpg"
                }
              />
              <Typography variant="h6">Wetsuits &amp; Accessories</Typography>
            </a>
          </Grid>
        </Grid>

        <GearSection />

        <Divider />

        <Hero minHeight={80} bg={"#fafafa"}>
          <Box sx={{}}>
            <Typography
              variant="h5"
              sx={{
                // textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Contact us at{" "}
              <Link href="tel:8312648008" underline="hover">
                <span>(831) 264-8008</span>
              </Link>{" "}
              for availability or rental reservations!
            </Typography>
          </Box>
        </Hero>

        <Divider />
        {/* 
        <Section id="surfboards">
          <Container>
            <Grid container>
              <Grid item md={12}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Surfboards</Typography>
                  <Typography variant="h6">
                    Continually-updated selection of various soft-top and
                    hard-top boards from high-quality brands.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="boogie">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Boogie Boards</Typography>
                  <Typography variant="h5">
                    Continually-updated selection of various boards from
                    reputable vendors.
                  </Typography>
                  <p>Board sizes we offer:</p>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net//public/2b122d8b-6449-42ad-8cdf-683fb8d1961b.jpg"
                    width={400}
                    height={400}
                    imgixParams={{ fit: "clamp" }}
                    htmlAttributes={{ style: { width: "100%" } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="wetsuits">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Wetsuits and Accessories</Typography>
                  <Typography variant="h5">
                    Continually-updated selection of various boards from
                    reputable vendors.
                  </Typography>
                  <p>Board sizes we offer:</p>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net//public/2b122d8b-6449-42ad-8cdf-683fb8d1961b.jpg"
                    width={400}
                    height={400}
                    imgixParams={{ fit: "clamp" }}
                    htmlAttributes={{ style: { width: "100%" } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section> 

        <Hero minHeight={400} bg="#35baf6">
          <Container>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Call us if you have any questions about the surf equipment we
              offer,
              <br />
              or need advice on choosing the right gear for yourself!
            </Typography>
          </Container>
        </Hero>*/}
      </Grid>
    </Layout>
  );
}

const GearSection = () => {
  return (
    <Box
      sx={{
        minHeight: 400,
        background: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6)), url(https://bigsurf1.imgix.net/equipment.jpg?w=1200) no-repeat`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        padding: 3,
      }}
    >
      <Container>
        <Grid
          container
          spacing={3}
          columns={{ md: 10, xs: 10 }}
          justifyContent="center"
        >
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/oneil.png" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/hyperflex.png" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/hotline.gif" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/Zinka-logo.png" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/catch-surf-logo.jpeg" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/NSP-Logo.jpg" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/ocean-and-earth-logo.jpg" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/odysea-logo.jpg" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/surftech-logo.png" />
          </Grid>
          <Grid item md={2} xs={3}>
            <EquipmentCard imgSrc="https://bigsurf1.imgix.net/storm-blade-logo.jpg" />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const EquipmentCard = ({ imgSrc }) => {
  return (
    <Paper
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={imgSrc}
        style={{ width: "90%", maxHeight: "100%", verticalAlign: "center" }}
      />
    </Paper>
  );
};

export const getServerSideProps = withSession(async function ({ req, res }) {
  const user = req.session.get("user") ?? null;
  return {
    props: { user },
  };
});
